(() => {
  const showPlaceholder = (imgElement, rawDomain) => {
    if (!imgElement) {
      return;
    }

    const logoContainer = imgElement.parentElement;
    if (!logoContainer) {
      return;
    }

    const label = String(rawDomain || imgElement.alt || 'Company')
      .trim()
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .charAt(0)
      .toUpperCase() || 'C';

    imgElement.remove();
    logoContainer.classList.add('logo-placeholder-frame');
    if (!logoContainer.querySelector('.logo-placeholder')) {
      const placeholder = document.createElement('span');
      placeholder.className = 'logo-placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      placeholder.textContent = label;
      logoContainer.appendChild(placeholder);
    }
  };

  window.handleStartupLogoError = (imgElement, rawDomain) => {
    showPlaceholder(imgElement, rawDomain);
  };
})();
